export default __webpack_public_path__ + "static/iconsProviders-24d4659a71fdee126ef073c13e99cd8a.svg";